/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Name_Cc_Move_Left_One_CharacterInputs */



/**
* | output |
* | --- |
* | "Move Left 1 Character" |
*
* @param {Shortcut_Keys_Name_Cc_Move_Left_One_CharacterInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_name_cc_move_left_one_character = /** @type {((inputs?: Shortcut_Keys_Name_Cc_Move_Left_One_CharacterInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Name_Cc_Move_Left_One_CharacterInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Deplacer d'un caractere vers la gauche")
	if (locale === "de") return /** @type {LocalizedString} */ ("Ein Zeichen nach links rücken")
	if (locale === "it") return /** @type {LocalizedString} */ ("Spostati di 1 carattere a sinistra")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Переместиться на 1 символ влево")
	if (locale === "es") return /** @type {LocalizedString} */ ("Mover 1 carácter a la izquierda")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("向左移动一个字符")
	if (locale === "ja") return /** @type {LocalizedString} */ ("1文字左に移動")
	if (locale === "hi") return /** @type {LocalizedString} */ ("एक वर्ण बाएं जाएं")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Mover um caractere para a esquerda")
	return /** @type {LocalizedString} */ ("Move Left 1 Character")
});